<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="img/TechnoTeams48.png"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />Hazz Management
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>Account</strong>
      </b-dropdown-header>
      <b-dropdown-item><i class="fa fa-shield" /></b-dropdown-item>
      <b-dropdown-item><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42, showModal:false  }
  },
  methods: {
    onClick(evt) {
      this.$root.$emit('bv::show::modal', 'viewModal', button)      
    },
    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    }
  },
}
</script>
